import { render, staticRenderFns } from "./MpExpression.vue?vue&type=template&id=47c56bcb&"
import script from "./MpExpression.vue?vue&type=script&lang=js&"
export * from "./MpExpression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports